export const displayUsername = (item) => {
  if (! item) {
    return '-';
  }

  if (item.first_name !== null && item.last_name !== null) {
    return `${item.first_name} ${item.last_name}`
  }

  return item.email ? `- (${item.email})` : '-';
};
